var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{ref:"activator",staticClass:"tooltip-activator",on:{"mouseenter":_vm.onEnter,"mouseleave":_vm.onLeave}},[_vm._t("default"),_c('span',{ref:"content",staticClass:"tooltip-hidden"},[_vm._t("content")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }